import React, {useEffect} from 'react';
import arrow from "../../../../images/down.svg";
import {Field} from "formik";
import {CustomCheckBox} from "../../../main/logbook/EditTable";
import {connect} from "react-redux";
import {getCommonData} from "../../../../redux/data/data-thunks";
import {COUNTRIES, FINISH_COUNTRIES, FINISH_MARINAS, MARINAS} from "../../../../redux/data/data-types";
import plus from "../../../../images/blue-plus.svg";
import {useTranslation} from "react-i18next";

const SailingRegion = ({
                         marinaStart, marinaFinish, countryFinish, countryStart, routeDetails,
                         isStartEqualsFinish, setFieldValue, handleChange, isDark, errors, submitCount, isEdit,
                         regionInfoRef, ...props
                       }) => {
  errors = submitCount > 0 ? errors : {}
  const {t} = useTranslation()
  useEffect(() => {
    if (!isEdit) {
      props.getCommonData(MARINAS)
      props.getCommonData(FINISH_MARINAS)
      props.getCommonData(COUNTRIES)
      props.getCommonData(FINISH_COUNTRIES)
    }
  }, [])
  useEffect(() => {
    if(errors.marinaStart || errors.marinaFinish || errors.countryStart || errors.countryFinish || errors.routeDetails) {
      regionInfoRef.current.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }, [errors.marinaStart, errors.marinaFinish, errors.countryStart, errors.countryFinish, errors.routeDetails])
  return (
    <div className="modal__section" ref={regionInfoRef}>
      <input defaultChecked={true}
             checked={errors.marinaStart || errors.marinaFinish || errors.countryStart || errors.countryFinish || errors.routeDetails}
             id={'check3'} type="checkbox" className={'modal__check'}/>
      <label htmlFor={'check3'} className="modal__subTitle">
        <h6 className="modal__underTitle">{t('sailRegion')}</h6>
        <div className="modal__collapse">
          <img src={arrow} alt=""/>
        </div>
      </label>
      <div className="modal__inputs">
        <div className="modal__inputItem">
          <p className="modal__label">{t('marinaStart')}:</p>
          <div className="modal__inputWrapper w-100">
            <Field placeholder={t('chooseMarinaStart')} value={marinaStart} id={'marinaStart'}
                   onBlur={() => props.getCommonData(FINISH_MARINAS, marinaStart)}
                   onChange={e => {
                     handleChange(e)
                     if (isStartEqualsFinish) setFieldValue('marinaFinish', e.target.value)
                     props.getCommonData(MARINAS, e.target.value)
                   }} type="text" className={`modal__input w-100 ${errors.marinaStart && 'modal__inputError'}`}
                   autoComplete={"off"}/>
            <div className="modal__list">
              <div className="modal__listItems">
                {props.marinas.filter(m => m.name.indexOf(marinaStart) !== -1).map((m, index) => (
                  <button className="modal__listItem"
                          onClick={() => {
                            setFieldValue('marinaStart', m.name)
                            if (isStartEqualsFinish) setFieldValue('marinaFinish', m.name)
                            if (m.country) {
                              if (isStartEqualsFinish) {
                                setFieldValue('countryFinish', m.country.name)
                                props.getCommonData(FINISH_COUNTRIES, m.country.name)
                              }
                              props.getCommonData(COUNTRIES, m.country.name)
                              setFieldValue('countryStart', m.country.name)
                            }
                          }} key={index}>
                    {m.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        {errors.marinaStart && <div className={'modal__inputItem mt-0'}>
          <p className="modal__label"/>
          <p className="modal__errorText">{errors.marinaStart}</p>
        </div>}
        <div className="modal__inputItem">
          <p className="modal__label">{t('countryStart')}: <span className={'required'}>*</span></p>
          <div className="modal__inputWrapper w-100">
            <Field placeholder={t('chooseCountryStart')} value={countryStart} id={'countryStart'}
                   onBlur={() => props.getCommonData(FINISH_COUNTRIES, countryStart)}
                   onChange={e => {
                     handleChange(e)
                     if (isStartEqualsFinish) setFieldValue('countryFinish', e.target.value)
                     props.getCommonData(COUNTRIES, e.target.value)
                   }} type="text" className={`modal__input w-100 ${errors.countryStart && 'modal__inputError'}`}
                   autoComplete={'off'}/>
            <div className="modal__list">
              <div className="modal__listItems">
                {props.countries.filter(c => c.name.indexOf(countryStart) !== -1).map((c, index) => <button
                  className="modal__listItem"
                  onClick={() => {
                    setFieldValue('countryStart', c.name)
                    if (isStartEqualsFinish) setFieldValue('countryFinish', c.name)
                  }} key={index}>
                  {c.name}
                </button>)}
              </div>
            </div>
          </div>
        </div>
        {errors.countryStart && <div className={'modal__inputItem mt-0'}>
          <p className="modal__label"/>
          <p className="modal__errorText">{errors.countryStart}</p>
        </div>}
        <div className="modal__inputItem">
          <p className="modal__label">Марина финиша:</p>
          <div className="modal__inputWrapper w-100">
            <CustomCheckBox isDark={isDark} isChecked={isStartEqualsFinish}
                            caption={t('equalStartFinish')}
                            onClick={() => {
                              if (!isStartEqualsFinish) {
                                setFieldValue('marinaFinish', marinaStart)
                                setFieldValue('countryFinish', countryStart)
                              } else {
                                setFieldValue('marinaFinish', '')
                                setFieldValue('countryFinish', '')
                                props.getCommonData(FINISH_COUNTRIES)
                                props.getCommonData(FINISH_MARINAS)
                              }
                              setFieldValue('isStartEqualsFinish', !isStartEqualsFinish)
                            }}
                            marginBottom={'0px'} fontFamily={'Lato400'} color={'#252526'}/>
          </div>
        </div>
        <div className="modal__inputInner">
          <p className="modal__label"/>
          <div className="modal__inputWrapper w-100">
            <Field placeholder={t('chooseMarinaFinish')} value={marinaFinish} id={'marinaFinish'}
                   onChange={e => {
                     handleChange(e)
                     props.getCommonData(FINISH_MARINAS, e.target.value)
                   }} type="text" className={`modal__input w-100 ${errors.marinaFinish && 'modal__inputError'}`}
                   autoComplete={'off'}
                   disabled={isStartEqualsFinish}/>
            <div className="modal__list">
              <div className="modal__listItems">
                {props.finishMarinas.filter(m => m.name.indexOf(marinaFinish) !== -1).map((m, index) => <button
                  className="modal__listItem"
                  onClick={() => {
                    setFieldValue('marinaFinish', m.name)
                    if (m.country) {
                      setFieldValue('countryFinish', m.country.name)
                      props.getCommonData(FINISH_COUNTRIES, m.country.name)
                    }
                  }} key={index}>
                  {m.name}
                </button>)}
              </div>
            </div>
          </div>
        </div>
        {errors.marinaFinish && <div className={'modal__inputItem mt-0'}>
          <p className="modal__label"/>
          <p className="modal__errorText">{errors.marinaFinish}</p>
        </div>}
        <div className="modal__inputItem">
          <p className="modal__label">{t('countryFinish')}: <span className={'required'}>*</span></p>
          <div className="modal__inputWrapper w-100">
            <Field placeholder={t('chooseFinishCountry')} value={countryFinish} id={'countryFinish'}
                   onChange={e => {
                     handleChange(e)
                     props.getCommonData(FINISH_COUNTRIES, e.target.value)
                   }} type="text" className={`modal__input w-100 ${errors.countryFinish && 'modal__inputError'}`}
                   autoComplete={'off'}
                   disabled={isStartEqualsFinish}/>
            <div className="modal__list">
              <div className="modal__listItems">
                {props.finishCountries.filter(c => c.name.indexOf(countryFinish) !== -1).map((c, index) => <button
                  className="modal__listItem"
                  onClick={() => setFieldValue('countryFinish', c.name)} key={index}>
                  {c.name}
                </button>)}
              </div>
            </div>
          </div>
        </div>
        {errors.countryFinish && <div className={'modal__inputItem mt-0'}>
          <p className="modal__label"/>
          <p className="modal__errorText">{errors.countryFinish}</p>
        </div>}
        <div className="modal__textareaItem">
          <p className="modal__label">{t('route')}:</p>
          <Field component={'textarea'} placeholder={t('routeDetails')} id={'routeDetails'}
                 value={routeDetails} onChange={e => {
            if (e.target.value.length < 350) {
              handleChange(e)
            }
          }} className={`modal__textarea ${errors.routeDetails && 'modal__inputError'}`}/>
        </div>
        {errors.routeDetails && <div className={'modal__inputItem mt-0'}>
          <p className="modal__errorText">{errors.routeDetails}</p>
        </div>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  marinas: state.dataReducer.marinas,
  finishMarinas: state.dataReducer.finishMarinas,
  countries: state.dataReducer.countries,
  finishCountries: state.dataReducer.finishCountries
})

export default connect(mapStateToProps, {getCommonData})(React.memo(SailingRegion));
